import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 1 };
const _hoisted_3 = { class: "columns" };
const _hoisted_4 = { class: "columns" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", null, null, -1);
const _hoisted_6 = { class: "columns" };
const _hoisted_7 = { class: "columns" };
const _hoisted_8 = { class: "columns" };
import { Validations, useValidation } from "@/composables/useValidation";
import { ProfileTypes, Site } from '@minicity/core';
import { onMounted, ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SiteProfileEditor',
    props: {
        modelValue: {}
    },
    emits: ['update:modelValue'],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const site = ref(null);
        const { areAllFieldsValid, validator } = useValidation();
        __expose({
            areAllFieldsValid
        });
        onMounted(() => {
            // Create a copy of the input prop - we're not supposed to mutate props directly!
            site.value = props.modelValue ? Object.assign({}, props.modelValue) : null;
        });
        // Event for two-way binding
        const emit = __emit;
        const onInput = () => {
            emit('update:modelValue', site.value);
        };
        return (_ctx, _cache) => {
            const _component_FormTextField = _resolveComponent("FormTextField");
            const _component_FormSelectField = _resolveComponent("FormSelectField");
            return (!site.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_FormTextField, {
                            label: "Name",
                            modelValue: site.value.name,
                            "onUpdate:modelValue": [
                                _cache[0] || (_cache[0] = ($event) => ((site.value.name) = $event)),
                                _cache[1] || (_cache[1] = ($event) => (onInput()))
                            ],
                            validator: _unref(validator)(_unref(Validations).notEmpty)
                        }, null, 8, ["modelValue", "validator"]),
                        _createVNode(_component_FormSelectField, {
                            label: "Nature",
                            modelValue: site.value.nature,
                            "onUpdate:modelValue": [
                                _cache[2] || (_cache[2] = ($event) => ((site.value.nature) = $event)),
                                _cache[3] || (_cache[3] = ($event) => (onInput()))
                            ],
                            options: _unref(Site).Nature,
                            validator: _unref(validator)(_unref(Validations).notEmpty)
                        }, null, 8, ["modelValue", "options", "validator"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_FormTextField, {
                            label: "Phone",
                            modelValue: site.value.profile.phone,
                            "onUpdate:modelValue": [
                                _cache[4] || (_cache[4] = ($event) => ((site.value.profile.phone) = $event)),
                                _cache[5] || (_cache[5] = ($event) => (onInput()))
                            ]
                        }, null, 8, ["modelValue"]),
                        _hoisted_5
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_FormTextField, {
                            label: "Building Number",
                            modelValue: site.value.profile.address.number,
                            "onUpdate:modelValue": [
                                _cache[6] || (_cache[6] = ($event) => ((site.value.profile.address.number) = $event)),
                                _cache[7] || (_cache[7] = ($event) => (onInput()))
                            ]
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_FormTextField, {
                            label: "Street",
                            modelValue: site.value.profile.address.street,
                            "onUpdate:modelValue": [
                                _cache[8] || (_cache[8] = ($event) => ((site.value.profile.address.street) = $event)),
                                _cache[9] || (_cache[9] = ($event) => (onInput()))
                            ]
                        }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_FormTextField, {
                            label: "City",
                            modelValue: site.value.profile.address.city,
                            "onUpdate:modelValue": [
                                _cache[10] || (_cache[10] = ($event) => ((site.value.profile.address.city) = $event)),
                                _cache[11] || (_cache[11] = ($event) => (onInput()))
                            ]
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_FormSelectField, {
                            label: "State",
                            modelValue: site.value.profile.address.state,
                            "onUpdate:modelValue": [
                                _cache[12] || (_cache[12] = ($event) => ((site.value.profile.address.state) = $event)),
                                _cache[13] || (_cache[13] = ($event) => (onInput()))
                            ],
                            options: _unref(ProfileTypes).StateNotUnknown
                        }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_FormTextField, {
                            label: "Postal Code",
                            modelValue: site.value.profile.address.postalCode,
                            "onUpdate:modelValue": [
                                _cache[14] || (_cache[14] = ($event) => ((site.value.profile.address.postalCode) = $event)),
                                _cache[15] || (_cache[15] = ($event) => (onInput()))
                            ],
                            numeric: "",
                            length: 9
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_FormTextField, {
                            label: "Country",
                            modelValue: site.value.profile.address.country,
                            "onUpdate:modelValue": [
                                _cache[16] || (_cache[16] = ($event) => ((site.value.profile.address.country) = $event)),
                                _cache[17] || (_cache[17] = ($event) => (onInput()))
                            ]
                        }, null, 8, ["modelValue"])
                    ])
                ]));
        };
    }
});
